import { DivergenceStatusEnum } from "@/enum/divergence-status"
import { NsuStatusEnum } from "@/enum/nsu-status"

import { DecisionStatus } from "./decision-consequence"
import {
  BATCH_ACTION_SCOPE,
  CLASSIFICATION_LABELS,
  DECISION_VOCABULARY,
} from "./messages"

export type BatchActionType = "approve" | "reject"
export type DataType = "divergence" | "nsu"

export const DATA_TYPES = {
  DIVERGENCE: "divergence" as const,
  NSU: "nsu" as const,
}

export const BATCH_STATUS_MAP: Record<
  BatchActionType,
  Record<DataType, DivergenceStatusEnum | NsuStatusEnum>
> = {
  approve: {
    divergence: DivergenceStatusEnum.APPROVED,
    nsu: NsuStatusEnum.APPROVED
  },
  reject: {
    divergence: DivergenceStatusEnum.REJECTED,
    nsu: NsuStatusEnum.REJECTED
  }
} as const

export const DIVERGENCE_DECISION_STATUS: Record<
  BatchActionType,
  DecisionStatus
> = {
  approve: DivergenceStatusEnum.APPROVED,
  reject: DivergenceStatusEnum.REJECTED,
}

interface BatchActionLabel {
  readonly modalTitle: string
  readonly buttonText: string
}

const batchActionLabelOf = (action: BatchActionType): BatchActionLabel => ({
  modalTitle: `${DECISION_VOCABULARY[action].verb} ${BATCH_ACTION_SCOPE.MODAL}`,
  buttonText: `${DECISION_VOCABULARY[action].verb} ${BATCH_ACTION_SCOPE.SELECTION}`,
})

export const BATCH_ACTION_LABELS: Record<BatchActionType, BatchActionLabel> = {
  approve: batchActionLabelOf("approve"),
  reject: batchActionLabelOf("reject"),
}

export const CONCILIATION_DATE_RANGE_FILTER_KEY = "conciliation_date_range" as const

export const STATUS_VARIANTS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  CLOSED: "closed",
  INACTIVE: "inactive",
  RESUBMISSION: "resubmission",
  DEFAULT: "default",
} as const

export const DIVERGENCE_STATUS_VARIANTS = {
  PENDING: STATUS_VARIANTS.PENDING,
  ACTIVE: STATUS_VARIANTS.DEFAULT,
  APPROVED: STATUS_VARIANTS.APPROVED,
  REJECTED: STATUS_VARIANTS.REJECTED,
  CLOSED: STATUS_VARIANTS.CLOSED,
  INACTIVE: STATUS_VARIANTS.INACTIVE,
} as const

export const CLASSIFICATION_BADGES = {
  PAYROLL_DISCOUNT: {
    variant: STATUS_VARIANTS.DEFAULT,
    label: CLASSIFICATION_LABELS.PAYROLL_DISCOUNT,
  },
  ACCOUNTED_LOSS: {
    variant: STATUS_VARIANTS.REJECTED,
    label: CLASSIFICATION_LABELS.ACCOUNTED_LOSS,
  },
  LOSS_WITHDRAWN: {
    variant: STATUS_VARIANTS.INACTIVE,
    label: CLASSIFICATION_LABELS.NOT_CLASSIFIED,
  },
} as const

export const SELECTION_LABELS = {
  single: "item selecionado",
  plural: "itens selecionados",
} as const

export const TABLE_STATES = {
  SELECTED: "selected",
} as const

export const EMPTY_STATE_MESSAGES = {
  noResults: "Nenhum resultado encontrado para os filtros aplicados.",
} as const
